import { AxiosError } from 'axios';

import {
  DOCUMENT_DATA__FETCH_FAILURE,
  DOCUMENT_DATA__FETCH_REQUEST,
  DOCUMENT_DATA__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import Document from '@app/store/document/Document';

export function fetchDocumentData(payload: { documentId: string }) {
  return {
    type: DOCUMENT_DATA__FETCH_REQUEST,
    payload,
  };
}

export function fetchDocumentDataSuccess(payload: { document: Document }) {
  return {
    type: DOCUMENT_DATA__FETCH_SUCCESS,
    payload,
  };
}

export function fetchDocumentDataFailure(error: AxiosError) {
  return {
    type: DOCUMENT_DATA__FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

export type DocumentDataAction =
  | ReturnType<typeof fetchDocumentData>
  | ReturnType<typeof fetchDocumentDataSuccess>
  | ReturnType<typeof fetchDocumentDataFailure>;
